import { defineStore } from 'pinia'

const maxAge = 60 * 60 * 24 * 7

export const useAfxStore = defineStore('consent', {
	namespaced: true,
	state: () => ({
		showBanner: true,
		consentReady: false,
	}),
	actions: {
		waitForAfx() {
			return new Promise((resolve) => {
				if (window.AfxIdentity?.anonymousLogin) {
					return resolve(true)
				}
				const interval = setInterval(() => {
					if (window.AfxIdentity?.anonymousLogin) {
						clearInterval(interval)
						resolve(true)
					}
				}, 50)

				setTimeout(() => {
					clearInterval(interval)
					resolve(false)
				}, 5000)
			})
		},

		async triggerAnonymousLoginIfReady() {
			const ready = await this.waitForAfx()

			if (
				ready &&
				typeof window?.AfxIdentity?.anonymousLogin === 'function'
			) {
				window.AfxIdentity.anonymousLogin()
			} else {
				console.warn('Afx script not ready')
			}
		},

		async acceptAfxConsent() {
			const consent = useCookie('consent', {
				sameSite: 'strict',
				maxAge: maxAge,
				default: () => false,
			})

			consent.value = true
			this.showBanner = false

			await nextTick()
			this.triggerAnonymousLoginIfReady()
		},

		syncBannerFromCookie() {
			const consent = useCookie('consent', {
				sameSite: 'strict',
				maxAge: maxAge,
				default: () => false,
			})

			this.showBanner = consent.value !== true
			this.consentReady = true
		},
	},
	// persist: {
	// 	pick: ['showBanner'],
	// 	storage: piniaPluginPersistedstate.cookies({
	// 		sameSite: 'strict',
	// 		expires: expiryDate,
	// 	}),
	// },
})
